"use client";

// packages/eden-table/src/components/THead.jsx
import TableSectionContext from './Table/TableSectionContext.js';
import { jsx } from "react/jsx-runtime";
var THead = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx("thead", { ...props, children: /* @__PURE__ */ jsx(TableSectionContext.Provider, { value: "thead", children }) });
};
THead.displayName = "THead";
var THead_default = THead;
export {
  THead_default as default
};
